// import { use, useEffect, useState } from "react";
// import {
//   uploadBankingAssessmentData,
//   downlaodBankingAssessmentTempalte,
//   getBankingInstitutionList,
//   inititateBank,
// } from "../../ActionCreator";
// import Popup from "../../../../../../presentationals/Popup/Popup.component";
// import CustomInput from "./CustomInput";
// import CustomSelect from "./CustomSelect";

// function Uploadpopup({ open, onClose, allDetail, setLoader, callAllApis }) {
//   const [popup, setPopup] = useState({ show: false, popupStatus: "" });
//   const [File, setFile] = useState(null);
//   const [data, setData] = useState({
//     accountNumber: "",
//     accountName: "",
//     institutionId: "",
//   });
//   const [institutionList, setInstitutionList] = useState([]);

//   const acceptedFormats = [".csv", ".xlsx", ".xls"];

//   const handleFileChange = (e) => {
//     const selected = e.target.files[0];
//     if (!selected) return;
//     setFile(selected);
//   };

//   const handleUpload = () => {
//     if (!File) return;

//     const formData = new FormData();
//     if (File) formData.append("file", File);
//     formData.append("accountNumber", data?.accountNumber);
//     formData.append("accountName", data?.accountName);
//     formData.append("accountType", data?.accountType);
//     setLoader(true);
//     uploadBankingAssessmentData(
//       allDetail?.applicationId,
//       formData,
//       (callback) => {
//         setLoader(false);
//         // handle response here
//         if (callback?.success == true) {
//           setPopup({ show: true, popupStatus: "file Uploaded Successfully" });
//           callAllApis();
//         } else {
//           setPopup({ show: true, popupStatus: "Error Uploading File" });
//         }
//         removePopup();
//       },
//     );
//   };

//   const handleDownloadTemplate = () => {
//     setLoader(true);
//     downlaodBankingAssessmentTempalte((callback) => {
//       setLoader(false);
//     });
//   };

//   const handleInputFields = (e, type) => {
//     setData((prev) => ({
//       ...prev,
//       [type]: e.target.value,
//     }));
//   };

//   const closePopup = () => {
//     setPopup({ show: false, popupStatus: "" });
//   };
//   const removePopup = () => {
//     setTimeout(() => {
//       closePopup();
//     }, 5000);
//   };

//   const canUpload = File;

//   const getBankingInstitutionListApi = () => {
//     getBankingInstitutionList((callback) => {
//       console.log("banking institution list", callback);
//       if (callback?.success) {
//         setInstitutionList(callback?.data?.institutions?.institution);
//       }
//     });
//   };

//   useEffect(() => {
//     getBankingInstitutionListApi();
//   }, [open]);

//   const handleInititateBank = () => {
//     inititateBank(
//       allDetail?.userId,
//       {
//         loanAmount: 100000,
//         loanDuration: 24,
//         loanType: "Home",
//         acceptancePolicy: "atLeastOneTransactionInRange",
//         yearMonthFrom: "2025-01",
//         yearMonthTo: "2025-12",
//         uploadingScannedStatements: false,
//         institutionId: data?.institutionId,
//       },
//       (callback) => {
//         console.log("inititate bank callback", callback);
//         if (callback?.success) {
//           setPopup({ show: true, popupStatus: "Bank Initiated Successfully" });
//           callAllApis();
//         } else {
//           setPopup({ show: true, popupStatus: "Error Initiating Bank" });
//         }
//       },
//     );
//   };

//   return (
//     <>
//       {popup?.show ? (
//         <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
//       ) : (
//         ""
//       )}
//       {open && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             backgroundColor: "rgba(0,0,0,0.45)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 999,
//           }}
//         >
//           <div
//             style={{
//               width: "520px",
//               padding: "24px",
//               backgroundColor: "#fff",
//               borderRadius: "12px",
//               position: "relative",
//               boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
//             }}
//           >
//             {/* Close */}
//             <span
//               onClick={onClose}
//               style={{
//                 position: "absolute",
//                 top: "12px",
//                 right: "16px",
//                 cursor: "pointer",
//                 fontSize: "20px",
//                 color: "#6b7280",
//                 lineHeight: 1,
//               }}
//             >
//               ✕
//             </span>

//             <h3
//               style={{
//                 margin: "0 0 20px 0",
//                 fontSize: "16px",
//                 fontWeight: 700,
//                 color: "#111827",
//               }}
//             >
//               Upload File
//             </h3>
//             <div
//               style={{
//                 display: "flex",
//                 flex: "1",
//                 flexDirection: "row",
//                 gap: "8px",
//                 marginBottom: "10px",
//               }}
//             >
//               {/* <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "8px" }}>
//                 <CustomInput
//                   type="number"
//                   value={data?.accountNumber} placeholder="Enter Account Number"
//                   onChange={(e) => handleInputFields(e, "accountNumber")}
//                   label={"Account Number"}
//                 />
//               </div> */}
//               {/* <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "8px" }}>

//                 <CustomInput
//                   type="text"
//                   value={data?.accountName} placeholder="Enter Name"
//                   onChange={(e) => handleInputFields(e, "accountName")}
//                   label={"Bank Holder Name"}
//                 />
//               </div> */}
//               <div
//                 style={{
//                   flex: 1,
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: "8px",
//                 }}
//               >
//                 <CustomSelect
//                   type="text"
//                   value={data?.accountType}
//                   placeholder="Enter Account Type"
//                   onChange={(e) => handleInputFields(e, "accountType")}
//                   label={"Account Type"}
//                   // options={[{label:"Saving",value:"Saving"},{label:"Current",value:"Current"},{label:"OD/CC",value:"OD/CC"},]}
//                   options={institutionList?.map((item) => ({
//                     label: item?.name,
//                     value: item?.id,
//                   }))}
//                 />
//               </div>
//             </div>

//             <div>
//               <button className="btn btn-primary" onClick={handleInititateBank}>
//                 Inititate Bank
//               </button>
//             </div>
//             {/* Two Upload Zones Side by Side */}
//             <div style={{ display: "flex", gap: "12px", marginBottom: "20px" }}>
//               <div
//                 style={{
//                   flex: 1,
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: "8px",
//                 }}
//               >
//                 <p
//                   style={{
//                     margin: 0,
//                     fontWeight: 600,
//                     fontSize: "13px",
//                     color: "#374151",
//                   }}
//                 >
//                   Bank Statement File
//                 </p>
//                 <div
//                   style={{
//                     position: "relative",
//                   }}
//                 >
//                   <div
//                     style={{
//                       border: `2px dashed ${File ? "#3b82f6" : "#d1d5db"}`,
//                       borderRadius: "8px",
//                       padding: "20px 10px",
//                       cursor: "pointer",
//                       textAlign: "center",
//                       backgroundColor: File ? "#eff6ff" : "#f9fafb",
//                       transition: "all 0.2s ease",
//                       minHeight: "90px",
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       gap: "6px",
//                       position: "relative",
//                       zIndex: "1",
//                     }}
//                   >
//                     {/* Upload Icon */}
//                     <svg
//                       width="24"
//                       height="24"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke={File ? "#3b82f6" : "#9ca3af"}
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     >
//                       <polyline points="16 16 12 12 8 16" />
//                       <line x1="12" y1="12" x2="12" y2="21" />
//                       <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
//                     </svg>
//                     <p
//                       style={{
//                         margin: 0,
//                         fontSize: "12px",
//                         color: File ? "#3b82f6" : "#6b7280",
//                         wordBreak: "break-all",
//                         padding: "0 4px",
//                       }}
//                     >
//                       {File ? File?.name : "Click to upload"}
//                     </p>
//                   </div>
//                   <input
//                     type="file"
//                     accept={acceptedFormats.join(",")}
//                     onChange={(e) => handleFileChange(e, "crif")}
//                     style={{
//                       opacity: "0",
//                       width: "100%",
//                       position: "absolute",
//                       inset: "0",
//                       zIndex: "2",
//                     }}
//                   />
//                 </div>
//               </div>
//             </div>

//             {/* Upload Button */}
//             <div style={{ display: "flex", gap: "10px" }}>
//               <button
//                 onClick={handleUpload}
//                 disabled={!canUpload}
//                 style={{
//                   width: "100%",
//                   padding: "10px",
//                   backgroundColor: canUpload ? "#2563eb" : "#d1d5db",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: "7px",
//                   cursor: canUpload ? "pointer" : "not-allowed",
//                   fontWeight: 600,
//                   fontSize: "14px",
//                   marginBottom: "16px",
//                   transition: "background-color 0.2s",
//                 }}
//               >
//                 Upload
//               </button>
//             </div>

//             {/* Divider */}
//             <div
//               style={{
//                 borderTop: "1px solid #e5e7eb",
//                 marginBottom: "14px",
//               }}
//             />

//             {/* Download Templates */}
//             <p
//               style={{
//                 margin: "0 0 10px 0",
//                 fontSize: "12px",
//                 fontWeight: 600,
//                 color: "#6b7280",
//                 textTransform: "uppercase",
//                 letterSpacing: "0.05em",
//               }}
//             >
//               Download Templates
//             </p>
//             <div style={{ display: "flex", gap: "10px" }}>
//               <button
//                 onClick={() => handleDownloadTemplate()}
//                 style={{
//                   flex: 1,
//                   padding: "8px 10px",
//                   backgroundColor: "#eff6ff",
//                   color: "#2563eb",
//                   border: "1px solid #bfdbfe",
//                   borderRadius: "6px",
//                   cursor: "pointer",
//                   fontSize: "13px",
//                   fontWeight: 500,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   gap: "6px",
//                 }}
//               >
//                 <svg
//                   style={{ width: "auto" }}
//                   width="14"
//                   height="14"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2.5"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 >
//                   <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
//                   <polyline points="7 10 12 15 17 10" />
//                   <line x1="12" y1="15" x2="12" y2="3" />
//                 </svg>
//                 Bank Statement Template
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// export default Uploadpopup;

// import { useEffect, useState } from "react";
// import {
//   uploadBankingAssessmentData,
//   downlaodBankingAssessmentTempalte,
//   getBankingInstitutionList,
//   inititateBank,
//   uploadBankingTransactionPdfData,
// } from "../../ActionCreator";
// import Popup from "../../../../../../presentationals/Popup/Popup.component";
// import CustomSelect from "./CustomSelect";

// function Uploadpopup({ open, onClose, allDetail, setLoader, callAllApis }) {
//   const [popup, setPopup] = useState({ show: false, popupStatus: "" });
//   const [file, setFile] = useState(null);
//   const [isBankInitiated, setIsBankInitiated] = useState(false);
//   const [inititateDataRes , setInititateDataRes] = useState(null);
//   const [data, setData] = useState({
//     institutionId: "",
//   });
//   const [institutionList, setInstitutionList] = useState([]);
//   const [uploadFileRes, setUploadFileRes] = useState(null);
//   console.log('inititateDataRes',inititateDataRes?.clientTransactionId)

//   // ✅ Only PDF
//   const acceptedFormats = [".pdf"];

//   const closePopup = () => {
//     setPopup({ show: false, popupStatus: "" });
//   };

//   const removePopup = () => {
//     setTimeout(closePopup, 4000);
//   };

//   // ---------------- FILE HANDLING ----------------
//   const handleFileChange = (e) => {
//     const selected = e.target.files[0];
//     if (!selected) return;

//     // ✅ Type validation
//     if (selected.type !== "application/pdf") {
//       setPopup({ show: true, popupStatus: "Only PDF files are allowed" });
//       return;
//     }

//     // ✅ Size validation (5MB)
//     if (selected.size > 5 * 1024 * 1024) {
//       setPopup({ show: true, popupStatus: "Max file size is 5MB" });
//       return;
//     }

//     setFile(selected);
//   };

//   // ---------------- INITIATE BANK ----------------
//   const handleInititateBank = () => {
//     if (!data?.institutionId) {
//       setPopup({ show: true, popupStatus: "Please select institution" });
//       return;
//     }

//     setLoader(true);

//     inititateBank(
//       allDetail?.userId,
//       {
//         loanAmount: 100000,
//         loanDuration: 24,
//         loanType: "Home",
//         acceptancePolicy: "atLeastOneTransactionInRange",
//         yearMonthFrom: "2025-01",
//         yearMonthTo: "2025-12",
//         uploadingScannedStatements: true,
//         institutionId: data?.institutionId,
//       },
//       (callback) => {
//         console.log('cfcndujik',callback)
//         setLoader(false);

//         if (callback?.success) {
//           setIsBankInitiated(true);
//           setInititateDataRes(callback?.data);
//           setPopup({
//             show: true,
//             popupStatus: "Bank Initiated Successfully",
//           });
//           setUploadFileRes(callback?.data);
//           // callAllApis();
//         } else {
//           setIsBankInitiated(false);
//           setPopup({ show: true, popupStatus: "Error Initiating Bank" });
//         }

//         removePopup();
//       }
//     );
//   };

//   // ---------------- UPLOAD ----------------
//   const handleUpload = () => {
//     if (!file || !isBankInitiated) return;

//     const formData = new FormData();
//     formData.append("file", file);

//     setLoader(true);

//     uploadBankingTransactionPdfData(
//       inititateDataRes?.clientTransactionId,
//       formData,
//       (callback) => {
//         setLoader(false);
//         if (callback?.success) {
//           setPopup({
//             show: true,
//             popupStatus: "File Uploaded Successfully",
//           });

//           setFile(null);
//           // callAllApis();
//         } else {
//           setPopup({ show: true, popupStatus: "Error Uploading File" });
//         }

//         removePopup();
//       }
//     );
//   };

//   // ---------------- FETCH BANK LIST ----------------
//   useEffect(() => {
//     if (!open) return;

//     getBankingInstitutionList((callback) => {
//       if (callback?.success) {
//         setInstitutionList(callback?.data?.institutions?.institution || []);
//       }
//     });
//   }, [open]);

//   const canUpload = file && isBankInitiated;

//   return (
//     <>
//       {popup?.show && (
//         <Popup popupStatus={popup.popupStatus} closePopup={closePopup} />
//       )}

//       {open && (
//         <div className="popup-overlay">
//           <div className="popup-card">
//             {/* Close */}
//             <span className="close-btn" onClick={onClose}>
//               ✕
//             </span>

//             <h3>Upload Bank Statement</h3>

//             {/* -------- STEP 1: SELECT BANK -------- */}
//             <CustomSelect
//               value={data?.institutionId}
//               placeholder="Select Bank"
//               label="Bank"
//               onChange={(e) =>
//                 setData(() => ({institutionId: e.target.value }))
//               }
//               options={institutionList.map((item) => ({
//                 label: item?.name,
//                 value: item?.id,
//               }))}
//             />

//             <button className="primary-btn" onClick={handleInititateBank}>
//               Initiate Bank
//             </button>

//             {/* -------- STEP 2: UPLOAD -------- */}
//             {!isBankInitiated && (
//               <p className="hint">
//                 Please initiate bank first to enable upload
//               </p>
//             )}

//             <div className="upload-box disabled={ !isBankInitiated }">
//               <p className="label">Bank Statement (PDF only)</p>

//               <div className={`dropzone ${file ? "active" : ""}`}>
//                 <p>{file ? file.name : "Click to upload PDF"}</p>

//                 <input
//                   type="file"
//                   accept="application/pdf"
//                   disabled={!isBankInitiated}
//                   onChange={handleFileChange}
//                 />
//               </div>
//             </div>

//             <button
//               className="upload-btn"
//               onClick={handleUpload}
//               disabled={!canUpload}
//               style={{
//                 marginTop:'10px'
//               }}
//             >
//               Upload
//             </button>

//             <hr />

//             {/* -------- TEMPLATE -------- */}
//             {/* <button
//               className="secondary-btn"
//               onClick={() => {
//                 setLoader(true);
//                 downlaodBankingAssessmentTempalte(() => setLoader(false));
//               }}
//             >
//               Download Template
//             </button> */}
//           </div>

//           {/* ---------- STYLES ---------- */}
//           <style jsx>{`
//             .popup-overlay {
//               position: fixed;
//               inset: 0;
//               background: rgba(0, 0, 0, 0.45);
//               display: flex;
//               justify-content: center;
//               align-items: center;
//               z-index: 999;
//             }

//             .popup-card {
//               width: 480px;
//               background: white;
//               padding: 24px;
//               border-radius: 12px;
//               position: relative;
//             }

//             .close-btn {
//               position: absolute;
//               right: 16px;
//               top: 10px;
//               cursor: pointer;
//             }

//             h3 {
//               margin-bottom: 16px;
//             }

//             .primary-btn {
//               width: 100%;
//               margin: 10px 0;
//               padding: 10px;
//               background: #2563eb;
//               color: white;
//               border: none;
//               border-radius: 6px;
//             }

//             .upload-btn {
//               width: 100%;
//               padding: 10px;
//               background: ${canUpload ? "#2563eb" : "#d1d5db"};
//               color: white;
//               border: none;
//               border-radius: 6px;
//               cursor: ${canUpload ? "pointer" : "not-allowed"};
//             }

//             .hint {
//               color: red;
//               font-size: 12px;
//             }

//             .dropzone {
//               border: 2px dashed #ccc;
//               padding: 20px;
//               text-align: center;
//               border-radius: 8px;
//               position: relative;
//             }

//             .dropzone.active {
//               border-color: #2563eb;
//               background: #eff6ff;
//             }

//             input[type="file"] {
//               position: absolute;
//               inset: 0;
//               opacity: 0;
//               cursor: pointer;
//             }
//           `}</style>
//         </div>
//       )}
//     </>
//   );
// }

// export default Uploadpopup;

/////////////////////////////////////////////////

// import { useEffect, useState } from "react";
// import {
//   getBankingInstitutionList,
//   inititateBank,
//   uploadBankingTransactionPdfData,
// } from "../../ActionCreator";
// import Popup from "../../../../../../presentationals/Popup/Popup.component";
// import CustomSelect from "./CustomSelect";

// function Uploadpopup({
//   open,
//   onClose,
//   allDetail,
//   setLoader,
//   allUploadedDocumentsForProcess,
//   callAllApis,
// }) {
//   console.log("fvijfkodl", allUploadedDocumentsForProcess);
//   const [popup, setPopup] = useState({ show: false, popupStatus: "" });
//   const [file, setFile] = useState(null);

//   const [data, setData] = useState({
//     institutionId: "",
//   });

//   const [institutionList, setInstitutionList] = useState([]);

//   // ✅ MAIN STATE (IMPORTANT)
//   const [clientTransactionId, setClientTransactionId] = useState(null);
//   const isBankInitiated = !!clientTransactionId;

//   // ---------------- POPUP ----------------
//   const showPopup = (msg) => {
//     setPopup({ show: true, popupStatus: msg });
//     setTimeout(() => setPopup({ show: false, popupStatus: "" }), 3000);
//   };

//   // ---------------- FILE ----------------
//   const handleFileChange = (e) => {
//     const selected = e.target.files[0];
//     if (!selected) return;

//     if (selected.type !== "application/pdf") {
//       return showPopup("Only PDF allowed");
//     }

//     if (selected.size > 5 * 1024 * 1024) {
//       return showPopup("Max 5MB allowed");
//     }

//     setFile(selected);
//   };

//   // ---------------- INITIATE ----------------
//   const handleInititateBank = () => {
//     // ✅ Already initiated → skip
//     if (clientTransactionId) {
//       return showPopup("Bank already initiated");
//     }

//     if (!data?.institutionId) {
//       return showPopup("Select bank first");
//     }

//     setLoader(true);

//     inititateBank(
//       allDetail?.userId,
//       {
//         loanAmount: 100000,
//         loanDuration: 24,
//         loanType: "Home",
//         acceptancePolicy: "atLeastOneTransactionInRange",
//         yearMonthFrom: "2025-01",
//         yearMonthTo: "2025-12",
//         uploadingScannedStatements: true,
//         institutionId: data.institutionId,
//       },
//       (res) => {
//         setLoader(false);

//         if (res?.success) {
//           const id = res?.data?.clientTransactionId;
//           setClientTransactionId(id);
//           showPopup("Bank Initiated Successfully");
//         } else {
//           showPopup("Failed to initiate bank");
//         }
//       },
//     );
//   };

//   // ---------------- UPLOAD ----------------
//   const handleUpload = () => {
//     if (!file) return showPopup("Select file first");

//     if (!clientTransactionId) {
//       return showPopup("Initiate bank first");
//     }

//     const formData = new FormData();
//     formData.append("file", file);

//     setLoader(true);

//     uploadBankingTransactionPdfData(clientTransactionId, formData, (res) => {
//       setLoader(false);
//       if (res?.success) {
//         showPopup("Uploaded successfully");
//         setFile(null);
//         callAllApis();
//       } else {
//         showPopup("Upload failed");
//       }
//     });
//   };

//   // ---------------- FETCH BANKS ----------------
//   useEffect(() => {
//     if (!open) return;

//     getBankingInstitutionList((res) => {
//       if (res?.success) {
//         setInstitutionList(res?.data?.institutions?.institution || []);
//       }
//     });
//   }, [open]);

//   const canUpload = file && clientTransactionId;

//   return (
//     <>
//       {popup.show && (
//         <Popup popupStatus={popup.popupStatus} closePopup={() => {}} />
//       )}

//       {open && (
//         <div className="popup-overlay">
//           <div className="popup-card">
//             <span className="close-btn" onClick={onClose}>
//               ✕
//             </span>

//             <h3>Upload Bank Statement</h3>

//             {/* -------- BANK SELECT -------- */}
//             <CustomSelect
//               value={data.institutionId}
//               placeholder="Select Bank"
//               label="Bank"
//               disabled={isBankInitiated}
//               onChange={(e) => setData({ institutionId: e.target.value })}
//               options={institutionList.map((item) => ({
//                 label: item.name,
//                 value: item.id,
//               }))}
//             />

//             <button
//               className="primary-btn"
//               onClick={handleInititateBank}
//               disabled={isBankInitiated}
//             >
//               {isBankInitiated ? "Bank Initiated" : "Initiate Bank"}
//             </button>

//             {/* -------- UPLOAD -------- */}
//             <div className="upload-box">
//               <p className="label">Upload PDF</p>

//               <div className={`dropzone ${file ? "active" : ""}`}>
//                 <p>{file ? file.name : "Click to upload PDF"}</p>

//                 <input
//                   type="file"
//                   accept="application/pdf"
//                   disabled={!isBankInitiated}
//                   onChange={handleFileChange}
//                 />
//               </div>
//             </div>

//             <button
//               className="upload-btn"
//               onClick={handleUpload}
//               disabled={!canUpload}
//               style={{
//                 marginTop: "10px",
//               }}
//             >
//               Upload
//             </button>

//             <div>
//               {allUploadedDocumentsForProcess?.map((item) => (
//                 <div
//                   key={item?.fileId}
//                   style={{
//                     marginBottom: "6px",
//                     padding: "8px",
//                     background: "#f3f4f6",
//                     borderRadius: "6px",
//                   }}
//                 >
//                   <p style={{ margin: 0, fontSize: "13px", color: "#111827" }}>
//                     {item?.originalFileName}
//                   </p>

//                   <button
//           style={{

//           }}

//                   >
//                     Process File
//                   </button>
//                 </div>
//               ))}
//             </div>

//             {/* -------- INFO -------- */}
//             {clientTransactionId && (
//               <p className="info">
//                 Transaction ID active → you can upload multiple PDFs
//               </p>
//             )}
//           </div>
//           <style jsx>{`
//             .popup-overlay {
//               position: fixed;
//               inset: 0;
//               background: rgba(0, 0, 0, 0.45);
//               display: flex;
//               justify-content: center;
//               align-items: center;
//               z-index: 999;
//             }

//             .popup-card {
//               width: 480px;
//               background: white;
//               padding: 24px;
//               border-radius: 12px;
//               position: relative;
//             }

//             .close-btn {
//               position: absolute;
//               right: 16px;
//               top: 10px;
//               cursor: pointer;
//             }

//             h3 {
//               margin-bottom: 16px;
//             }

//             .primary-btn {
//               width: 100%;
//               margin: 10px 0;
//               padding: 10px;
//               background: #2563eb;
//               color: white;
//               border: none;
//               border-radius: 6px;
//             }

//             .upload-btn {
//               width: 100%;
//               padding: 10px;
//               background: ${canUpload ? "#2563eb" : "#d1d5db"};
//               color: white;
//               border: none;
//               border-radius: 6px;
//               cursor: ${canUpload ? "pointer" : "not-allowed"};
//             }

//             .hint {
//               color: red;
//               font-size: 12px;
//             }

//             .dropzone {
//               border: 2px dashed #ccc;
//               padding: 20px;
//               text-align: center;
//               border-radius: 8px;
//               position: relative;
//             }

//             .dropzone.active {
//               border-color: #2563eb;
//               background: #eff6ff;
//             }

//             input[type="file"] {
//               position: absolute;
//               inset: 0;
//               opacity: 0;
//               cursor: pointer;
//             }
//           `}</style>
//         </div>
//       )}
//     </>
//   );
// }

// export default Uploadpopup;

import { useEffect, useState } from "react";
import {
  getBankingInstitutionList,
  inititateBank,
  uploadBankingTransactionPdfData,
  processBankingFile,
  getKycVerificationByUserIdNew,
  getAllUploadedDocumentsListForProcessByUserId,
} from "../../ActionCreator";
import Popup from "../../../../../../presentationals/Popup/Popup.component";
import CustomSelect from "./CustomSelect";
import { Loader } from "lucide-react";

function Uploadpopup({
  open,
  onClose,
  allDetail,
  setLoader,
  // allUploadedDocumentsForProcess,
  callAllApis,
}) {
  const [popup, setPopup] = useState({ show: false, popupStatus: "" });
  const [file, setFile] = useState(null);
  const [data, setData] = useState({ institutionId: "" , userId: ''});

  const [institutionList, setInstitutionList] = useState([]);
  const [clientTransactionId, setClientTransactionId] = useState(null);
  const [allusers, setAllUsers] = useState([]);
  const [ allUploadedDocumentsForProcess,setAllUploadedDocumentsForProcess] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);

  // { [fileId]: { isPasswordProtected: null | true | false, password: "" } }
  const [fileSettings, setFileSettings] = useState({});

  const isBankInitiated = !!clientTransactionId;
  const canUpload = file && clientTransactionId;

  const showPopup = (msg) => {
    setPopup({ show: true, popupStatus: msg });
    setTimeout(() => setPopup({ show: false, popupStatus: "" }), 3000);
  };

  const getFileSetting = (fileId) =>
    fileSettings[fileId] || { isPasswordProtected: null, password: "" };

  const updateFileSetting = (fileId, updates) => {
    setFileSettings((prev) => ({
      ...prev,
      [fileId]: { ...getFileSetting(fileId), ...updates },
    }));
  };

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (!selected) return;
    if (selected.type !== "application/pdf")
      return showPopup("Only PDF files are allowed");
    if (selected.size > 5 * 1024 * 1024)
      return showPopup("File size must be under 5MB");
    setFile(selected);
    e.target.value = "";
  };

  const handleInititateBank = () => {
    // if (clientTransactionId) return showPopup("Bank already initiated");
    if (!data?.userId) return showPopup("Please select a user first");
    if (!data?.institutionId) return showPopup("Please select a bank first");

    setLoader(true);
    inititateBank(
      data?.userId,
      {
        loanAmount: 100000,
        loanDuration: 24,
        loanType: "Home",
        acceptancePolicy: "atLeastOneTransactionInRange",
        yearMonthFrom: "2025-01",
        yearMonthTo: "2025-12",
        uploadingScannedStatements: true,
        institutionId: data.institutionId,
      },
      (res) => {
        setLoader(false);
        if (res?.success) {
          setClientTransactionId(res?.data?.clientTransactionId);
          showPopup("Bank initiated successfully");
        } else {
          showPopup(res?.data?.message || res?.message || "Failed to initiate bank");
        }
      },
    );
  };

  const handleUpload = () => {
    if (!file) return showPopup("Please select a file first");
    if (!clientTransactionId) return showPopup("Please initiate bank first");

    const formData = new FormData();
    formData.append("file", file);

    setBtnLoading(true);
    uploadBankingTransactionPdfData(clientTransactionId, formData, (res) => {
      setBtnLoading(false);
      if (res?.success) {
        showPopup("Uploaded successfully — you can upload another file");
        setFile(null);
        getUploadedDocumentsListForProcess()
        // callAllApis();
      } else {
        showPopup( res?.data?.message || res?.message || "Upload failed");
      }
    },(error)=>{
      setBtnLoading(false);
       showPopup(error?.response?.data?.message || res?.message || "Process failed");
    });
  };

  const handleProcessFile = (item) => {
    const setting = getFileSetting(item.fileId);
    const { isPasswordProtected, password } = setting;

    if (isPasswordProtected === null)
      return showPopup("Select password option first");
    if (isPasswordProtected && !password.trim())
      return showPopup("Enter the PDF password");

    const payload = {
      fileId: item.fileId,
      institutionId: item.institutionId,
      ...(isPasswordProtected && { password: password.trim() }),
    };

    setBtnLoading(true);
    processBankingFile(
      item?.clientTransactionId,
      payload,
      (res) => {
        setBtnLoading(false);
        if (res?.success === true) {
          showPopup("File processed successfully");
          callAllApis();
        } else {
          showPopup(res?.data?.message || res?.message || "Process failed");
        }
      },
      (error) => {
        console.log("process error", error);
         showPopup(error?.response?.data?.message || res?.message || "Process failed");
        setBtnLoading(false);
      },
    );
  };

  useEffect(() => {
    if (!open) return;
    getBankingInstitutionList((res) => {
      if (res?.success) {
        setInstitutionList(res?.data?.institutions?.institution || []);
      }
    });
    getAllUsers()
  }, [open]);

  if (!open) return null;

  const styles = {
    overlay: {
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 999,
    },
    card: {
      width: 500,
      maxHeight: "90vh",
      overflowY: "auto",
      background: "#fff",
      padding: "28px 24px",
      borderRadius: 14,
      position: "relative",
      boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
    },
    closeBtn: {
      position: "absolute",
      right: 16,
      top: 12,
      cursor: "pointer",
      fontSize: 18,
      color: "#6b7280",
      lineHeight: 1,
    },
    title: {
      margin: "0 0 18px",
      fontSize: 17,
      fontWeight: 600,
      color: "#111827",
    },
    label: {
      fontSize: 12,
      fontWeight: 500,
      color: "#6b7280",
      margin: "0 0 6px",
    },
    sectionTitle: {
      fontSize: 13,
      fontWeight: 600,
      color: "#374151",
      margin: "0 0 8px",
    },
    divider: {
      border: "none",
      borderTop: "1px solid #e5e7eb",
      margin: "16px 0",
    },
    initiateBtn: (initiated) => ({
      width: "100%",
      margin: "10px 0",
      padding: "10px",
      background: initiated ? "#93c5fd" : "#2563eb",
      color: "#fff",
      border: "none",
      borderRadius: 7,
      fontWeight: 600,
      cursor: initiated ? "not-allowed" : "pointer",
      fontSize: 14,
      letterSpacing: 0.2,
    }),
    uploadBtn: (active) => ({
      width: "100%",
      padding: "10px",
      marginTop: 8,
      background: active ? "#2563eb" : "#e5e7eb",
      color: active ? "#fff" : "#9ca3af",
      border: "none",
      borderRadius: 7,
      fontWeight: 600,
      cursor: active ? "pointer" : "not-allowed",
      fontSize: 14,
    }),
    dropzone: (hasFile) => ({
      border: `2px dashed ${hasFile ? "#2563eb" : "#d1d5db"}`,
      padding: "20px 16px",
      borderRadius: 8,
      textAlign: "center",
      position: "relative",
      background: hasFile ? "#eff6ff" : "#fafafa",
      transition: "all 0.2s",
    }),
    dropzoneText: (hasFile) => ({
      margin: 0,
      fontSize: 13,
      color: hasFile ? "#1d4ed8" : "#9ca3af",
    }),
    fileInput: (enabled) => ({
      position: "absolute",
      inset: 0,
      opacity: 0,
      cursor: enabled ? "pointer" : "not-allowed",
    }),
    hintText: {
      fontSize: 12,
      color: "#6b7280",
      margin: "6px 0 4px",
      textAlign: "center",
    },
    fileCard: {
      marginBottom: 10,
      padding: "14px",
      background: "#f9fafb",
      border: "1px solid #e5e7eb",
      borderRadius: 8,
    },
    fileName: {
      margin: "0 0 10px",
      fontSize: 13,
      fontWeight: 500,
      color: "#111827",
      display: "flex",
      alignItems: "center",
      gap: 6,
      wordBreak: "break-all",
    },
    toggleBtn: (active) => ({
      flex: 1,
      padding: "7px 0",
      fontSize: 13,
      fontWeight: 600,
      border: `2px solid ${active ? "#2563eb" : "#d1d5db"}`,
      background: active ? "#eff6ff" : "#fff",
      color: active ? "#2563eb" : "#6b7280",
      borderRadius: 6,
      cursor: "pointer",
      transition: "all 0.15s",
    }),
    passwordInput: {
      width: "100%",
      padding: "8px 10px",
      fontSize: 13,
      border: "1.5px solid #d1d5db",
      borderRadius: 6,
      marginBottom: 10,
      outline: "none",
      boxSizing: "border-box",
      color: "#111827",
    },
    processBtn: (active) => ({
      width: "100%",
      padding: "8px 0",
      fontSize: 13,
      fontWeight: 600,
      background: active ? "#16a34a" : "#e5e7eb",
      color: active ? "#fff" : "#9ca3af",
      border: "none",
      borderRadius: 6,
      cursor: active ? "pointer" : "not-allowed",
      transition: "background 0.15s",
    }),
  };

  const getAllUsers = () => {
    getKycVerificationByUserIdNew(
      allDetail?.userId,
      (res) => {
        console.log("KYC res", res);
        const usersData = res?.data || {};

        const allUsers = Object.entries(usersData)
          .filter(([_, users]) => Array.isArray(users))
          .flatMap(([userType, users]) =>
            users.map((user) => ({
              ...user,
              userType,
            })),
          );

        setAllUsers(allUsers);
      },
      (err) => {
        console.log("Errpr to get KYC", err);
      },
    );
  };

  const handleclose = () => {
    setFile(null)
    setData({ institutionId: "" , userId: ''})
    setInstitutionList([])
    setClientTransactionId(null)
    setAllUsers([])
    setFileSettings({})
    onClose()

  }

   const getUploadedDocumentsListForProcess = () => {
      // setLoader(true);
      getAllUploadedDocumentsListForProcessByUserId(
        data?.userId,
        (callback) => {
          // setLoader(false);
          console.log('fnujidkolp', callback)
          if(callback?.success === true){
              setAllUploadedDocumentsForProcess(callback?.data ?? [])
          }
        },
        (error) => {
          // setLoader(false);
         
        },
      );
    };
  return (
    <>
      {popup.show && (
        <Popup popupStatus={popup.popupStatus} closePopup={() => {}} />
      )}

      <div style={styles.overlay}>
        <div style={styles.card}>
          {/* ── Close ── */}
          <span style={styles.closeBtn} onClick={handleclose}>
            ✕
          </span>

          {/* ── Title ── */}
          <h3 style={styles.title}>Upload Bank Statement</h3>

          <CustomSelect
            value={data.userId}
            placeholder="Select User"
            label="Select User"
            onChange={(e) => setData((pre) => ({ ...pre, userId: e.target.value }))}
            options={
              (allusers?.filter((user) => user?.userType === "BORROWER") || []).length > 0
                ? allusers
                    ?.filter((user) => user?.userType === "BORROWER")
                    ?.map((user) => ({
                      label: `${user?.businessName ?? "Unknown Business"} - ${user?.userType}`,
                      value: user?.userId,
                    }))
                : [
                    {
                      label: "No users found",
                      value: "",
                    },
                  ]
            }
          />

         <div style={{
          marginTop:'5px'
         }}>
           <CustomSelect
            value={data.institutionId}
            placeholder="Select Bank"
            label="Bank"
            disabled={isBankInitiated}
            onChange={(e) => setData((pre) => ({ ...pre, institutionId: e.target.value }))}
            options={institutionList.map((item) => ({
              label: item.name,
              value: item.id,
            }))}
            
          />
         </div>

          <button
            onClick={handleInititateBank}
            // disabled={isBankInitiated}
            style={styles.initiateBtn()}
          >
            {isBankInitiated ? "✓ Bank Initiated" : "Initiate Bank"}
          </button>

          <hr style={styles.divider} />

          {/* ── Dropzone ── */}
          <p style={styles.sectionTitle}>Upload PDF</p>
          <div style={styles.dropzone(!!file)}>
            <p style={styles.dropzoneText(!!file)}>
              {file ? `📄 ${file.name}` : "Click to select PDF (max 5MB)"}
            </p>
            <input
              type="file"
              accept="application/pdf"
              disabled={!isBankInitiated}
              onChange={handleFileChange}
              style={styles.fileInput(isBankInitiated)}
            />
          </div>

          {/* ── Upload Button ── */}
          <button
            onClick={handleUpload}
            disabled={!canUpload}
            style={styles.uploadBtn(canUpload)}
          >
            
            Upload
          </button>

          {/* ── Multi-upload hint ── */}
          {isBankInitiated && (
            <p style={styles.hintText}>
              ℹ️ Transaction active — upload as many PDFs as needed
            </p>
          )}

          {/* ── Uploaded Files ── */}
          {allUploadedDocumentsForProcess?.length > 0 && (
            <>
              <hr style={styles.divider} />
              <p style={styles.sectionTitle}>
                Uploaded Files
              </p>

              {allUploadedDocumentsForProcess
                ?.filter((item) => item.processStatus !== "processed")
                ?.map((item) => {
                  const setting = getFileSetting(item.fileId);
                  const { isPasswordProtected, password } = setting;
                  const canProcess =
                    isPasswordProtected === false ||
                    (isPasswordProtected === true &&
                      password.trim().length > 0);

                  return (
                    <div key={item.fileId} style={styles.fileCard}>
                      {/* File name */}
                      <p style={styles.fileName}>📄 {item.originalFileName}</p>

                      {/* Password protected question */}
                      <p style={styles.label}>
                        Is this PDF password protected?
                      </p>

                      <div
                        style={{ display: "flex", gap: 8, marginBottom: 10 }}
                      >
                        <button
                          style={styles.toggleBtn(isPasswordProtected === true)}
                          onClick={() =>
                            updateFileSetting(item.fileId, {
                              isPasswordProtected: true,
                              password: "",
                            })
                          }
                        >
                          🔒 Yes
                        </button>

                        <button
                          style={styles.toggleBtn(
                            isPasswordProtected === false,
                          )}
                          onClick={() =>
                            updateFileSetting(item.fileId, {
                              isPasswordProtected: false,
                              password: "",
                            })
                          }
                        >
                          🔓 No
                        </button>
                      </div>

                      {/* Password input — only when YES */}
                      {isPasswordProtected === true && (
                        <input
                          type="password"
                          placeholder="Enter PDF password"
                          value={password}
                          onChange={(e) =>
                            updateFileSetting(item.fileId, {
                              password: e.target.value,
                            })
                          }
                          style={styles.passwordInput}
                        />
                      )}

                      {/* Process button — visible only after Yes or No is selected */}
                      {isPasswordProtected !== null && (
                        <button
                          onClick={() => handleProcessFile(item)}
                          disabled={!canProcess}
                          style={styles.processBtn(canProcess)}
                         
                        >
                          {
                            btnLoading ? <Loader height={15} /> : "Process File"
                          }
                     
                        </button>
                      )}
                    </div>
                  );
                })}
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default Uploadpopup;
